import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { PageShell } from '../../components/layout/PageShell'
import { PageBrow } from '../../components/layout/PageBrow'
import ServiceRail from '../../components/service/ServiceRail'
import SectionView from '../../components/service/SectionView'
import { serviceApi } from '../../services/api'

type Section = 'employees' | 'clients' | 'partners'
const TITLES: Record<Section, string> = { employees: 'Employees', clients: 'Clients', partners: 'Partners' }

export default function EmotionalPulse() {
  const [params, setParams] = useSearchParams()
  const section = (params.get('section') as Section) || 'employees'
  const [relative, setRelative] = useState(false)
  const [running, setRunning] = useState(false)
  const setSection = (s: Section) => setParams((p) => { p.set('section', s); return p })
  const runAnalysis = async () => { setRunning(true); try { await serviceApi.analyze() } finally { setRunning(false) } }

  return (
    <PageShell
      rail2={<ServiceRail section={section} relative={relative} running={running} onSection={setSection} onRelative={setRelative} onRun={runAnalysis} />}
      brow={<PageBrow left={<div className="min-w-0"><h1 className="truncate text-[15px] font-semibold text-foreground">{TITLES[section]}</h1><p className="truncate text-xs text-muted-foreground">emotional pulse · 30 days</p></div>} />}
    >
      <div className="p-6"><SectionView key={section} kind={section} relative={relative} /></div>
    </PageShell>
  )
}
